module.exports = __webpack_public_path__ + "static/alert-system-alert-dont-b485bcca42db6a5651c09696af629406.png";